import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "assets/images/logo.png";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();
    this.state = {
      openMenus: {}
    };
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  // Check if any child route is active
  isChildActive(children) {
    if (!children) return false;
    return children.some(child =>
      this.props.location.pathname === (child.layout + child.path)
    );
  }

  toggleMenu(key) {
    this.setState(prev => ({
      openMenus: {
        ...prev.openMenus,
        [key]: !prev.openMenus[key]
      }
    }));
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a
            href="https://dev.dhbtools.com/"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="react-logo" />
            </div>
          </a>
          <a
            href="https://dev.dhbtools.com/"
            className=" simple-text logo-normal"
          >
            DHB Tools
          </a>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <Nav>
            {this.props.routes.filter(r => !r.hidden).map((prop, key) => {
              // Nếu là "divider" => hiển thị <hr>
              if (prop.divider) {
                return (
                  <hr
                    key={key}
                    style={{
                      border: '0',
                      height: '1px',
                      backgroundColor: '#909090',
                      width: '80%',
                      margin: '10px auto',
                    }}
                  />
                );
              }

              // Route có children => hiển thị submenu collapse
              if (prop.children) {
                const isOpen = this.state.openMenus[key] || false;
                return (
                  <li key={key}>
                    <a
                      href="#!"
                      className="nav-link"
                      onClick={(e) => { e.preventDefault(); this.toggleMenu(key); }}
                      style={{
                        cursor: 'pointer',
                        opacity: 1,
                        background: 'transparent'
                      }}
                    >
                      <i className={prop.icon} />
                      <p style={{ display: 'inline', flex: 1 }}>{prop.name}</p>
                      <i
                        className={isOpen ? "fas fa-chevron-down" : "fas fa-chevron-right"}
                        style={{
                          fontSize: 10,
                          opacity: 0.5,
                          position: 'absolute',
                          right: 15,
                          top: '50%',
                          transform: 'translateY(-50%)'
                        }}
                      />
                    </a>
                    <Collapse isOpen={isOpen}>
                      <ul className="nav" style={{ paddingLeft: 15, listStyle: 'none' }}>
                        {prop.children.filter(c => !c.hidden).map((child, cKey) => (
                          <li
                            key={cKey}
                            className={this.activeRoute(child.path)}
                          >
                            <NavLink
                              to={child.layout + child.path}
                              className="nav-link"
                              activeClassName="active"
                              style={{ fontSize: 13, padding: '8px 15px 8px 20px' }}
                            >
                              <i className={child.icon} style={{ fontSize: 13 }} />
                              <p>{child.name}</p>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </Collapse>
                  </li>
                );
              }

              // Route bình thường
              return (
                <li
                  className={
                    this.activeRoute(prop.path) + (prop.pro ? "" : "")
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
